import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PrintService, UsbDriver } from 'ng-thermal-print';

import { comedorModulo } from '../../diccionarios/comedorModulo';
import type { ComedorDiccionario } from '../../diccionarios/comedorModulo';
import { ComedorService } from '../../services/comedor.services';
import { UtilsService } from '../../../../shared/utils/utils.service';
import { MarcacionModel } from '../../models/marcacionModel';
import { LocalStorageKey, LocalstorageService } from '../../../../services/localstorage.service';
import { Printer } from '../../../../model/printer.model';
import { DatosColaboradores, MarcacionResponse, turnoResponse } from '../../models/api.model';

@Component({
  selector: 'app-registro-comida',
  templateUrl: './registro-comida.component.html',
  styleUrls: ['./registro-comida.component.css']
})
export class RegistroComidaComponent implements OnInit {

  formulario: FormGroup;
  dataUsuario: DatosColaboradores;
  diccionarioModulo: ComedorDiccionario = comedorModulo;
  comedorTipo: string;
  enviarIdEvento: string;
  cmbTipo: any[];

  loading: boolean = false;

  usbPrintDriver  : UsbDriver;
  printerStatus   : boolean = false;
  printer?        : Printer
  ComedorPrecios  : any[];
  aplicaJugo      : boolean = false;
  tipoComida      : turnoResponse | null = {id: 0, comida:'', secuencia: '0', turno: '', menu:'NO-ENCONTRADO' }; //Feat: T30882 AppComedor Programa nutricional

  constructor(private fb: FormBuilder,
    private rutaActiva: ActivatedRoute,
    private servicioWeb: ComedorService,
    private utilServices: UtilsService,
    private printService: PrintService,
    private localStorageService: LocalstorageService) {
      this.startPrinter()
    }

  ngOnInit() {
    this.cmbTipo = [{ id: 1, tipo: 'TARJETA' },
    { id: 2, tipo: 'CEDULA' }];
    this.rutaActiva.params.subscribe((params: Params) => {
      console.log('Router-Params: ' + params.origen);
      switch (params.origen) {
        case 'Com_Prin': {
          this.comedorTipo = 'PRINCIPAL';
          break;
        }
        case 'Com_Favo': {
          // this.comedorTipo = 'FAVORITA';
          this.comedorTipo = 'PLANTA SUR';
          break;
        }
        case 'Com_AGG': {
          this.comedorTipo = 'GUAYAQUIL';
          break;
        }
        case 'Com_Otel': {
          // this.comedorTipo = 'OTELO';
          this.comedorTipo = 'PLANTA NORTE';

          break;
        }
        case 'Com_PtaDet': {
          // this.comedorTipo = 'OTELO';
          this.comedorTipo = 'PLANTA DETERGENTE';

          break;
        }
        default: {
          this.comedorTipo = 'MULTIUSOS';
          break;
        }
      }
      this.enviarIdEvento = params.origen;
      this.ubicarLocalidadPrecios();
    });

    this.formulario = this.fb.group({
      tipo: ['', [Validators.required]],
      tarjeta: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(13)]],
      jugoExtra: ['0', [Validators.minLength(1), Validators.maxLength(4)]],
      aplicaJugo: [false, []]
    });

    this.formulario.get('aplicaJugo').valueChanges.subscribe((valor) =>{
      let cantidad = valor ? 1 : 0;
      this.formulario.get('jugoExtra').setValue(cantidad);
    });

    this.llenarVacioObjeto();
    this.getTurnoActual(); //Feat: T30882 AppComedor Programa nutricional
  }

  onKeydown(event) {
    console.log(this.formulario.get('tarjeta').value);
    if (this.formulario.get('tipo').value === 1) { //1--> Tajeta
      if ((this.formulario.valid === true)) {
        //this.enviarTarjeta(this.formulario.get('tarjeta').value);
        console.log('ENTRO EN EL IF KEYDOWN');
      }
    }

    if (this.formulario.get('tipo').value === 2) {
      if ((event.key === 'Enter' && this.formulario.valid === true)) {
        //this.enviarTarjeta(this.formulario.get('tarjeta').value);
        console.log('ENTER --> KEYDOWN');
      }
    }
  }//

  buscarServicio() {
    this.loading = true;
    const tipo = this.formulario.get('tipo').value;
    const tarjeta = this.formulario.get('tarjeta').value;
    this.servicioWeb.getBuscarColaboradorFavorita(tipo, tarjeta, this.enviarIdEvento).subscribe((resp: DatosColaboradores) => {
      this.dataUsuario = resp;
      if (this.dataUsuario.nombre === undefined) {
        this.llenarVacioObjeto();
        this.utilServices.mensajeErrorVisto('Usuario no encontrado.');
      } else {
        if (this.dataUsuario.comedor === true) {
          this.enviarMarcacion('SIN VALE');
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }, (error) => {
      this.utilServices.mensajeErrorVisto(error.error.message);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    });
  }

  enviarTarjeta() {
    console.log(JSON.stringify(this.formulario.value));
  }

  llenarVacioObjeto() {
    const mostrar = 'NO-ENCONTRADO';
    this.dataUsuario = {
      nombre: mostrar, apellido: mostrar,
      departamento: mostrar, cedula: mostrar,
      cargo: mostrar, id: mostrar, comedor: false
    };
  }

  enviarMarcacion(innStatus: string) {
    const enviarIdPerson = this.formulario.get('tipo').value === 1 ? this.dataUsuario.cedula : this.formulario.get('tarjeta').value;
    const enviarObjeto = new MarcacionModel(enviarIdPerson, this.enviarIdEvento, innStatus, this.formulario.get('aplicaJugo').value);
    this.servicioWeb.postMarcacion(enviarObjeto).subscribe((resp: MarcacionResponse) => {
      this.formulario.get('tarjeta').setValue('');
      this.formulario.get('aplicaJugo').setValue(false);
      document.getElementById('tarjeta').focus();
      this.utilServices.mensajeOKVisto(this.dataUsuario.nombre, false, 1000);
      
      //Feat: T30882 AppComedor Programa nutricional
      this.tipoComida.menu = resp.tc_turno;
      this.tipoComida.secuencia = resp.tc_secuencia != 'Reimpresion' ? resp.tc_secuencia : this.tipoComida.secuencia;
      //END
      
      if (this.printerStatus)
        this.printTicket(resp)
      // this.llenarVacioObjeto();
    }, (error) => {
      this.formulario.get('tarjeta').setValue('');
      this.utilServices.mensajeErrorVisto(error.error.message);
    });
  }

  private startPrinter() {
    this.printer = this.localStorageService.getValue<Printer>(LocalStorageKey.PRINTER)

    this.printService.isConnected.subscribe((result) => {
      this.printerStatus = result;
      if (result) {
        console.log('Connected to printer!!!');
      } else {
        console.log('Not connected to printer.');
      }
    })

    if (!this.printer) {
      this.usbPrintDriver = new UsbDriver()
    } else {
      this.usbPrintDriver = new UsbDriver(this.printer.vendor, this.printer.product)
      this.printService.setDriver(this.usbPrintDriver, 'ESC/POS');
    }
  }

  requestUsbPrinter() {
    this.usbPrintDriver.requestUsb().subscribe((device) => {
      this.printService.setDriver(this.usbPrintDriver, 'ESC/POS')
      this.printer = {
        vendor: device.vendorId,
        product: device.productId
      }
      this.localStorageService.setValue<Printer>(LocalStorageKey.PRINTER, this.printer)
    });
  }

  private printTicket(data: MarcacionResponse) {
    let ticket = `Ticket #${data.tc_secuencia}`
    if (data.tc_secuencia === 'Reimpresion') {
      ticket = data.tc_secuencia
    }
    if(data.tc_jugo != null ){
      this.printService.init()
      .setBold(true)
      .setJustification('center')
      .setSize('large')
      .writeLine('La Fabril S.A.')
      .setUnderline(true)
      .writeLine(`${ticket}`)
      .setUnderline(false)
      .setBold(false)
      .setSize('normal')
      .setJustification('left')
      .feed(1)
      .writeLine(`  Colaborador : ${data.tc_cedula}`)
      .writeLine(`  ${data.tc_nombre}`)
      .writeLine(`  Comedor     : ${data.tc_comedor}`)
      .writeLine(`  Fecha       : ${data.tc_fecha}`)
      .writeLine(`  Turno       : ${data.tc_turno}`)
      .writeLine(`  Jugo Adic.  : ${data.tc_jugo != null ? data.tc_jugo : 0}`)
      .feed(4)
      .cut('full')
      .flush();
    }else{
      this.printService.init()
      .setBold(true)
      .setJustification('center')
      .setSize('large')
      .writeLine('La Fabril S.A.')
      .setUnderline(true)
      .writeLine(`${ticket}`)
      .setUnderline(false)
      .setBold(false)
      .setSize('normal')
      .setJustification('left')
      .feed(1)
      .writeLine(`  Colaborador : ${data.tc_cedula}`)
      .writeLine(`  ${data.tc_nombre}`)
      .writeLine(`  Comedor     : ${data.tc_comedor}`)
      .writeLine(`  Fecha       : ${data.tc_fecha}`)
      .writeLine(`  Turno       : ${data.tc_turno}`)
      .feed(4)
      .cut('full')
      .flush();
    }
    
  }

  doSomething(){
    if(this.aplicaJugo)
      if(this.formulario.get('aplicaJugo').value){
        this.utilServices.alertifyToast("Se deshabilitó el jugo");
        this.formulario.get('aplicaJugo').setValue(false);
      }else{
        this.utilServices.alertifyToastOK("Se habilitó el jugo");
        this.formulario.get('aplicaJugo').setValue(true);
      }
  }

  ubicarLocalidadPrecios(){
    this.servicioWeb.getComedoresLocalidad().subscribe((res) => {
      let localidad = res.filter(x => x.idComedor === this.enviarIdEvento)[0].localidad;
      console.log("Localidad del Comedor ==> ", localidad);
      this.servicioWeb.getComidasPreciosxLocalidad(localidad).subscribe((response) => {
        if(response.length > 0){
          this.ComedorPrecios = response;
          this.aplicaJugo = response.filter(y => y.tipoComida === "JUGO").length >= 1;
          console.log("APLICA JUGO", this.aplicaJugo);
        }else{
          this.utilServices.mensajeErroToast("NO EXISTEN CONFIGURACION SOLICITE INGRESO DE PRECIOS");
          this.aplicaJugo = false;
        }
      }, (err) => { 
        console.log(err.err.message);
      });

    },(err) => { 
      console.log(err.message);
    });
  }

  //Feat: T30882 AppComedor Programa nutricional
  enDesarrollo : boolean = true;
  getTurnoActual(){
    this.servicioWeb.getTurnos().subscribe((response: turnoResponse) => {
      if(response){
        this.tipoComida = response;
        this.tipoComida.turno = response.descripcion+'_'+this.tipoComida.comida;
      }else{
        this.utilServices.mensajeOKToast("No se encontró turno", 3000);
        this.tipoComida = null;
      }
      this.tipoComida.menu = 'NO-ENCONTRADO';
    }, (err) => { 
      console.log(err.message); 
    });
  }

}